import React from 'react'
import { useTranslation } from 'react-i18next'
import { Row, Paragraph, Ellipsis, LayoutBand, Avatar, Divider } from '@fs/zion-ui'
import ClickToCopy from '@fs/zion-click-to-copy'
import type { Person } from '@fs/zion-tree-types'
import { getNameInPreferredScript } from '@fs/zion-person-service'
import { usePreference } from '@fs/zion-preferences'
import StickyHeader from './StickyHeader'
import PersonPageTabs from '../PersonPageTabs'

type Props = {
  focusPerson: Person
  showTemple: boolean
}

export default function MiniHeader({ focusPerson, showTemple }: Props): JSX.Element {
  const [t] = useTranslation()
  const showNameInRomanScriptPreference = usePreference('tree.showNamesInRomanScript')
  return (
    <StickyHeader>
      <div aria-hidden="true">
        <LayoutBand maxWidth="lg" marginY="nano" marginX="nano">
          <Row alignY="middle">
            <Avatar src={focusPerson.portraitUrl} sex={focusPerson.gender?.toLowerCase()} />
            <Paragraph>
              <Ellipsis>
                {focusPerson?.name
                  ? getNameInPreferredScript(focusPerson, Boolean(showNameInRomanScriptPreference)).fullName
                  : t('tree-person.unknown.label')}
              </Ellipsis>
            </Paragraph>

            {focusPerson?.lifespan && (
              <Paragraph noShrinkX size="sm">
                {focusPerson.lifespan}
              </Paragraph>
            )}

            <ClickToCopy
              noShrinkX
              emphasis="low"
              value={focusPerson.id}
              copiedMessage={t('tree-person.person-header-copied.label')}
              analyticsEventName="person-id-copied"
            />
          </Row>
        </LayoutBand>

        <Divider />

        <LayoutBand maxWidth="lg">
          <PersonPageTabs growX showTemple={showTemple} />
        </LayoutBand>
      </div>
    </StickyHeader>
  )
}
